import { useState } from "react";
import useCollection from "./useCollection";
import {
   
    ChevronDown,
    ChevronLeft
} from "lucide-react";
export default function CollectionDescription({

    className = "",

    collapsed = true,

}) {

    const collection = useCollection();

    const [expanded, setExpanded] = useState(false);

    if (!collection?.description)
        return null;

    return (

        <section
            className={`collection-description ${className}`}
        >

            <div
                className={
                    collapsed && !expanded
                        ? "collection-description__text collapsed"
                        : "collection-description__text"
                }
            >

                {collection.description}

            </div>

            {collapsed && (
                <div className="products-footer-button">
                    <button
                        className="collection-description__toggle"
                        onClick={() =>
                            setExpanded(!expanded)
                        }
                    >

                        {expanded
                            ?
                            (<div className="show-more">
                                نمایش کمتر
                                <ChevronLeft className="ChevronLeft" />
                            </div>)
                            :
                            (<div className="show-more">
                                نمایش بیشتر
                                <ChevronDown className="ChevronDown" />
                            </div>)
                        }

                    </button>

                </div>



            )}

        </section>
    );
}